import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { UnsupportedMediaTypeExceptionCIOasihkge9oc44 as UnsupportedMediaTypeExceptionCIO } from './internals/Errors.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { MultiPart_getInstance1qrv90sa9uvz5 as MultiPart_getInstance } from '../../../../../ktor-ktor-http/io/ktor/http/ContentTypes.mjs';
import {
  ByteString10sanmoo66key as ByteString,
  ByteString3c9fk8lsh3lvs as ByteString_0,
} from '../../../../../kotlinx-io-kotlinx-io-bytestring/kotlinx/io/bytestring/ByteString.mjs';
import {
  IOException1wyutdmfe71nu as IOException,
  EOFExceptionh831u25jcq9n as EOFException,
} from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/-PlatformJs.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  Char__toInt_impl_vasixdnyockrdnmht5 as Char__toInt_impl_vasixd,
  _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { toString1h6jjoch8cjt8 as toString_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import { toByte4i43936u611k as toByte } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { copyOfRange3alro60z4hhf8 as copyOfRange } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import {
  produce1iljho2c8bp6o as produce,
  ProducerScopeb3mmhvfa6ll7 as ProducerScope,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Produce.mjs';
import { startsWith641pyr7vf687 as startsWith } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  readUntil3qqal0dj72fys as readUntil,
  copyTo2si6ixg3c5rjz as copyTo,
  skipIfFound34xzbgurmhd09 as skipIfFound,
  readRemaining1u8soafhjma7y as readRemaining,
  readPacket1qzyfym3sry67 as readPacket,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannelOperations.mjs';
import { CharArrayBuilder1n2d9vhxvtt4u as CharArrayBuilder } from './internals/CharArrayBuilder.mjs';
import { parseHeaderswkac0gpavig as parseHeaders } from './HttpParser.mjs';
import { parseDecLongacrqck1443il as parseDecLong } from './internals/Chars.mjs';
import {
  add2suhfggl4zvkk as add,
  fromInt2ii0rejb1w62w as fromInt,
  subtract2orl8z9upxd9l as subtract,
  convertToInty04h231mmjoh as convertToInt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  WriterScope3b0bo1enaee6b as WriterScope,
  writer1eia5its2a1fh as writer,
  close3semq7pafb42g as close,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteWriteChannelOperations.mjs';
import { counted3iniv3aql3f9n as counted } from '../../../../../ktor-ktor-io/io/ktor/utils/io/CountedByteReadChannel.mjs';
import { get_remaining1lapv95kcmm0y as get_remaining } from '../../../../../ktor-ktor-io/io/ktor/utils/io/core/ByteReadPacket.mjs';
import { ByteChannel3cxdguezl3lu7 as ByteChannel } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteChannel.mjs';
import { CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CompletableDeferred.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { toByteArray1i3ns5jnoqlv6 as toByteArray } from '../../../../../ktor-ktor-io/io/ktor/utils/io/core/Strings.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_CrLf() {
  _init_properties_Multipart_kt__ato98a();
  return CrLf;
}
var CrLf;
function get_PrefixString() {
  _init_properties_Multipart_kt__ato98a();
  return PrefixString;
}
var PrefixString;
var PreambleClass;
function Preamble() {
  if (PreambleClass === VOID) {
    class $ extends MultipartEvent() {
      constructor(body) {
        super();
        this.v5d_1 = body;
      }
    }
    initMetadataForClass($, 'Preamble');
    PreambleClass = $;
  }
  return PreambleClass;
}
var MultipartPartClass;
function MultipartPart() {
  if (MultipartPartClass === VOID) {
    class $ extends MultipartEvent() {
      constructor(headers, body) {
        super();
        this.w5d_1 = headers;
        this.x5d_1 = body;
      }
    }
    initMetadataForClass($, 'MultipartPart');
    MultipartPartClass = $;
  }
  return MultipartPartClass;
}
var EpilogueClass;
function Epilogue() {
  if (EpilogueClass === VOID) {
    class $ extends MultipartEvent() {
      constructor(body) {
        super();
        this.y5d_1 = body;
      }
    }
    initMetadataForClass($, 'Epilogue');
    EpilogueClass = $;
  }
  return EpilogueClass;
}
var MultipartEventClass;
function MultipartEvent() {
  if (MultipartEventClass === VOID) {
    class $ {}
    initMetadataForClass($, 'MultipartEvent');
    MultipartEventClass = $;
  }
  return MultipartEventClass;
}
function parseMultipart(_this__u8e3s4, input, contentType, contentLength, maxPartSize) {
  maxPartSize = maxPartSize === VOID ? 9223372036854775807n : maxPartSize;
  _init_properties_Multipart_kt__ato98a();
  if (!MultiPart_getInstance().x4z(contentType)) {
    throw UnsupportedMediaTypeExceptionCIO().c5e('Failed to parse multipart: Content-Type should be multipart/* but it is ' + toString(contentType));
  }
  var boundaryByteBuffer = parseBoundaryInternal(contentType);
  var boundaryBytes = ByteString().z4i(boundaryByteBuffer);
  return parseMultipart_0(_this__u8e3s4, boundaryBytes, input, contentLength, maxPartSize);
}
function parseBoundaryInternal(contentType) {
  _init_properties_Multipart_kt__ato98a();
  var boundaryParameter = findBoundary(contentType);
  if (boundaryParameter === -1) {
    throw IOException().f4m("Failed to parse multipart: Content-Type's boundary parameter is missing");
  }
  var boundaryStart = boundaryParameter + 9 | 0;
  var boundaryBytes = new Int8Array(74);
  var position = {_v: 0};
  parseBoundaryInternal$put(position, boundaryBytes, 13);
  parseBoundaryInternal$put(position, boundaryBytes, 10);
  parseBoundaryInternal$put(position, boundaryBytes, 45);
  parseBoundaryInternal$put(position, boundaryBytes, 45);
  var state = 0;
  var inductionVariable = boundaryStart;
  var last = charSequenceLength(contentType);
  if (inductionVariable < last)
    loop: do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var ch = charSequenceGet(contentType, i);
      // Inline function 'kotlin.code' call
      var v = Char__toInt_impl_vasixd(ch) & 65535;
      if ((v & 65535) > 127) {
        throw IOException().f4m('Failed to parse multipart: wrong boundary byte 0x' + toString_0(v, 16) + ' - should be 7bit character');
      }
      switch (state) {
        case 0:
          if (ch !== _Char___init__impl__6a9atx(32))
            if (ch === _Char___init__impl__6a9atx(34)) {
              state = 2;
            } else if (ch === _Char___init__impl__6a9atx(59) || ch === _Char___init__impl__6a9atx(44)) {
              break loop;
            } else {
              state = 1;
              parseBoundaryInternal$put(position, boundaryBytes, toByte(v));
            }

          break;
        case 1:
          if (ch === _Char___init__impl__6a9atx(32) || ch === _Char___init__impl__6a9atx(44) || ch === _Char___init__impl__6a9atx(59)) {
            break loop;
          } else {
            parseBoundaryInternal$put(position, boundaryBytes, toByte(v));
          }

          break;
        case 2:
          if (ch === _Char___init__impl__6a9atx(92)) {
            state = 3;
          } else if (ch === _Char___init__impl__6a9atx(34)) {
            break loop;
          } else {
            parseBoundaryInternal$put(position, boundaryBytes, toByte(v));
          }

          break;
        case 3:
          parseBoundaryInternal$put(position, boundaryBytes, toByte(v));
          state = 2;
          break;
      }
    }
     while (inductionVariable < last);
  if (position._v === 4) {
    throw IOException().f4m('Empty multipart boundary is not allowed');
  }
  return copyOfRange(boundaryBytes, 0, position._v);
}
function parseMultipart_0(_this__u8e3s4, boundaryPrefixed, input, totalLength, maxPartSize) {
  _init_properties_Multipart_kt__ato98a();
  return produce(_this__u8e3s4, VOID, VOID, parseMultipart$slambda_0(input, boundaryPrefixed, maxPartSize, totalLength));
}
function findBoundary(contentType) {
  _init_properties_Multipart_kt__ato98a();
  var state = 0;
  var paramNameCount = 0;
  var inductionVariable = 0;
  var last = charSequenceLength(contentType) - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var ch = charSequenceGet(contentType, i);
      switch (state) {
        case 0:
          if (ch === _Char___init__impl__6a9atx(59)) {
            state = 1;
            paramNameCount = 0;
          }

          break;
        case 1:
          if (ch === _Char___init__impl__6a9atx(61)) {
            state = 2;
          } else if (ch === _Char___init__impl__6a9atx(59)) {
            paramNameCount = 0;
          } else if (ch === _Char___init__impl__6a9atx(44)) {
            state = 0;
          } else if (ch !== _Char___init__impl__6a9atx(32))
            if (paramNameCount === 0 && startsWith(contentType, 'boundary=', i, true)) {
              return i;
            } else {
              paramNameCount = paramNameCount + 1 | 0;
            }

          break;
        case 2:
          if (ch === _Char___init__impl__6a9atx(34))
            state = 3;
          else if (ch === _Char___init__impl__6a9atx(44))
            state = 0;
          else if (ch === _Char___init__impl__6a9atx(59)) {
            state = 1;
            paramNameCount = 0;
          }

          break;
        case 3:
          if (ch === _Char___init__impl__6a9atx(34)) {
            state = 1;
            paramNameCount = 0;
          } else if (ch === _Char___init__impl__6a9atx(92)) {
            state = 4;
          }

          break;
        case 4:
          state = 3;
          break;
      }
    }
     while (inductionVariable <= last);
  return -1;
}
function *parsePreambleImpl(boundary, input, output, limit, $completion) {
  limit = limit === VOID ? 9223372036854775807n : limit;
  return yield* readUntil(input, boundary, output, limit, true, $completion);
}
function *parsePartHeadersImpl(input, $completion) {
  var builder = new (CharArrayBuilder())();
  try {
    var tmp0_elvis_lhs = yield* parseHeaders(input, builder, VOID, $completion);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw EOFException().k4j('Failed to parse multipart headers: unexpected end of stream');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  } catch ($p) {
    if ($p instanceof Error) {
      var t = $p;
      builder.x2m();
      throw t;
    } else {
      throw $p;
    }
  }
}
function *parsePartBodyImpl(boundaryPrefixed, input, output, headers, limit, $completion) {
  var tmp0_safe_receiver = headers.d2p('Content-Length');
  var contentLength = tmp0_safe_receiver == null ? null : parseDecLong(tmp0_safe_receiver);
  var tmp;
  if (contentLength == null) {
    tmp = yield* readUntil(input, boundaryPrefixed, output, limit, true, $completion);
  } else {
    if (0n <= contentLength ? contentLength <= limit : false) {
      tmp = add(yield* copyTo(input, output, contentLength, $completion), yield* skipIfFoundReadCount(input, boundaryPrefixed, $completion));
    } else {
      throwLimitExceeded(contentLength, limit);
    }
  }
  var byteCount = tmp;
  yield* output.c4o($completion);
  return byteCount;
}
function *skipIfFoundReadCount(_this__u8e3s4, prefix, $completion) {
  var tmp;
  if (yield* skipIfFound(_this__u8e3s4, prefix, $completion)) {
    tmp = fromInt(prefix.q2());
  } else {
    tmp = 0n;
  }
  return tmp;
}
function throwLimitExceeded(actual, limit) {
  _init_properties_Multipart_kt__ato98a();
  throw IOException().f4m('Multipart content length exceeds limit ' + actual.toString() + ' > ' + limit.toString() + '; ' + "limit is defined using 'formFieldLimit' argument");
}
function parseBoundaryInternal$put(position, boundaryBytes, value) {
  if (position._v >= boundaryBytes.length) {
    throw IOException().f4m("Failed to parse multipart: boundary shouldn't be longer than 70 characters");
  }
  var _unary__edvuaz = position._v;
  position._v = _unary__edvuaz + 1 | 0;
  boundaryBytes[_unary__edvuaz] = value;
}
var parseMultipart$slambda$slambdaClass;
function parseMultipart$slambda$slambda() {
  if (parseMultipart$slambda$slambdaClass === VOID) {
    class $ {
      constructor($firstBoundary, $countedInput) {
        this.d5e_1 = $firstBoundary;
        this.e5e_1 = $countedInput;
      }
      *f5e($this$writer, $completion) {
        yield* /*#__NOINLINE__*/parsePreambleImpl(this.d5e_1, this.e5e_1, $this$writer.a4p_1, 8193n, $completion);
        yield* $this$writer.a4p_1.e4o($completion);
        return Unit_instance;
      }
      od(p1, $completion) {
        return this.f5e(p1 instanceof WriterScope() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    parseMultipart$slambda$slambdaClass = $;
  }
  return parseMultipart$slambda$slambdaClass;
}
function parseMultipart$slambda$slambda_0($firstBoundary, $countedInput) {
  var i = new (parseMultipart$slambda$slambda())($firstBoundary, $countedInput);
  var l = ($this$writer, $completion) => i.f5e($this$writer, $completion);
  l.$arity = 1;
  return l;
}
var parseMultipart$slambdaClass;
function parseMultipart$slambda() {
  if (parseMultipart$slambdaClass === VOID) {
    class $ {
      constructor($input, $boundaryPrefixed, $maxPartSize, $totalLength) {
        this.g5e_1 = $input;
        this.h5e_1 = $boundaryPrefixed;
        this.i5e_1 = $maxPartSize;
        this.j5e_1 = $totalLength;
      }
      *k5e($this$produce, $completion) {
        var countedInput = counted(this.g5e_1);
        var readBeforeParse = countedInput.q4p();
        var firstBoundary = this.h5e_1.a4j(get_PrefixString().q2());
        var preambleData = yield* readRemaining(writer($this$produce, VOID, VOID, parseMultipart$slambda$slambda_0(firstBoundary, countedInput)).y4o_1, $completion);
        if (get_remaining(preambleData) > 0n) {
          yield* $this$produce.g1b(new (Preamble())(preambleData), $completion);
        }
        $l$loop: while (!countedInput.u4n() && !(yield* skipIfFound(countedInput, get_PrefixString(), $completion))) {
          yield* skipIfFound(countedInput, get_CrLf(), $completion);
          if (yield* skipIfFound(countedInput, firstBoundary, $completion)) {
            continue $l$loop;
          }
          var body = new (ByteChannel())();
          var headers = CompletableDeferred();
          var part = new (MultipartPart())(headers, body);
          yield* $this$produce.g1b(part, $completion);
          var headersMap = null;
          try {
            headersMap = yield* /*#__NOINLINE__*/parsePartHeadersImpl(countedInput, $completion);
            if (!headers.w12(headersMap)) {
              headersMap.x2m();
              throw CancellationException().n('Multipart processing has been cancelled');
            }
            yield* /*#__NOINLINE__*/parsePartBodyImpl(this.h5e_1, countedInput, body, headersMap, this.i5e_1, $completion);
            body.l6();
          } catch ($p) {
            if ($p instanceof Error) {
              var cause = $p;
              if (headers.x12(cause)) {
                var tmp0_safe_receiver = headersMap;
                if (tmp0_safe_receiver == null)
                  null;
                else {
                  tmp0_safe_receiver.x2m();
                }
              }
              close(body, cause);
              throw cause;
            } else {
              throw $p;
            }
          }
        }
        yield* skipIfFound(countedInput, get_CrLf(), $completion);
        yield* skipIfFound(countedInput, get_CrLf(), $completion);
        if (!(this.j5e_1 == null)) {
          var consumedExceptEpilogue = subtract(countedInput.q4p(), readBeforeParse);
          var size = subtract(this.j5e_1, consumedExceptEpilogue);
          if (size > 2147483647n)
            throw IOException().f4m('Failed to parse multipart: prologue is too long');
          if (size > 0n) {
            yield* $this$produce.g1b(new (Epilogue())(yield* readPacket(countedInput, convertToInt(size), $completion)), $completion);
          }
        } else {
          var epilogueContent = yield* readRemaining(countedInput, $completion);
          if (!epilogueContent.v3z()) {
            yield* $this$produce.g1b(new (Epilogue())(epilogueContent), $completion);
          }
        }
        return Unit_instance;
      }
      od(p1, $completion) {
        return this.k5e((!(p1 == null) ? isInterface(p1, ProducerScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    parseMultipart$slambdaClass = $;
  }
  return parseMultipart$slambdaClass;
}
function parseMultipart$slambda_0($input, $boundaryPrefixed, $maxPartSize, $totalLength) {
  var i = new (parseMultipart$slambda())($input, $boundaryPrefixed, $maxPartSize, $totalLength);
  var l = ($this$produce, $completion) => i.k5e($this$produce, $completion);
  l.$arity = 1;
  return l;
}
var properties_initialized_Multipart_kt_wu0sh0;
function _init_properties_Multipart_kt__ato98a() {
  if (!properties_initialized_Multipart_kt_wu0sh0) {
    properties_initialized_Multipart_kt_wu0sh0 = true;
    CrLf = ByteString().z4i(toByteArray('\r\n'));
    PrefixString = ByteString_0(new Int8Array([45, 45]));
  }
}
//region block: exports
export {
  parseMultipart as parseMultipart2ddxudhdihg70,
};
//endregion

//# sourceMappingURL=Multipart.mjs.map
